var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#26B6EA"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.97 3.429L6.857 6.33v11.254l5.113 2.988l5.173-2.988V6.33zm.03.857L8.141 6.6l3.857 2.25l3.857-2.25zm-4.287 3v3.857l3.429-1.92zm4.715 2.785v3.858l3.428-1.92zm3.857-2.785v3.857l-3.429-1.92zM11.57 10.07v3.858l-3.429-1.92zm-3.857 2.6v4.474L12 19.714l4.286-2.571v-4.475L11.999 15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.714 18.51v-2.653h.857v2.229l2.143 1.105v.952zM19.285 5.49v2.653h-.857V5.914L16.285 4.81v-.952z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtm);
export default __webpack_public_path__ + "static/media/ftm.57631e9d1130c12df166a2074c8e564b.svg";
export { ForwardRef as ReactComponent };